import React from "react";

import CommonValues from "../common/utils";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import ProposalCover from "./Templates/Template-1/ProposalCover";
import Description from "./Templates/Template-1/Description";
import ProposalBreakdown from "./Templates/Template-1/ProposalBreakdown";
import ProposalComparison from "./Templates/Template-1/ProposalComparison";
import AcceptanceForm from "./Templates/Template-1/AcceptanceForm";
import ContactUs from "./Templates/Template-1/ContactUs";
import ProposalCover2 from "./Templates/Template-2/ProposalCover";
import AcceptanceForm2 from "./Templates/Template-2/AcceptanceForm";
import ContactUs2 from "./Templates/Template-2/ContactUs";
import CompanyOverview from "./Templates/Template-2/CompanyOverview";
import ProposalBreakdown2 from "./Templates/Template-2/ProposalBreakdown";
import ProposalComparison2 from "./Templates/Template-2/ProposalComparison";
import ShowVideo from "./Templates/Template-1/ShowVideo";
import ShowVideo2 from "./Templates/Template-2/ShowVideo";
import AtkButton from "../AtlaskitControls/AtkButton";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Guid } from "js-guid";

export default function GeneratedProposal(props: any) {
  const navigate = useNavigate();
  const [primaryColor, setPrimaryColor] = useState("#243353");
  const [secondaryColor, setSecondaryColor] = useState("#E0677D");
  const [preparedBy, setPreparedBy] = useState<any>("");
  const [preparedFor, setPreparedFor] = useState<any>("");
  const [ourProposal, setOurProposal] = useState<any>("");
  const [website, setWebsite] = useState("");
  const [aboutUs, setAboutUs] = useState("");
  const [companyOverview, setCompanyOverview] = useState("");
  const [vision, setVision] = useState("");
  const [mission, setMission] = useState("");
  const [companyDetails, setCompanyDetails] = useState({});
  const [logoURL, setLogoURL] = useState("");
  const [proposalType, setProposalType] = useState("");
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([{ name: "", role: "" }]);
  const [loading, setLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const [videoUrl, setVideoUrl] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [acceptanceFormDescription, setAcceptanceFormDescription] = useState("");
  const [proposalComparisonDescription, setProposalComparisonDescription] = useState("");
  const [proposalBreakdownDescription, setProposalBreakdownDescription] = useState("");
  const [policyDetails, setPolicyDetails] = useState("");
  const [coverageDetails, setCoverageDetails] = useState("");
  const [assetsInformation, setAssetsInformation] = useState("");
  const [title, setTitle] = useState("");
  const [templateImages, setTemplateImages] = useState("");
  const [endorsementsExclusions, setEndorsementsExclusions] = useState("");

  const toast: any = useRef("");

  type TeamMember = {
    name: string;
    role: string;
  };
  useEffect(() => {
    if (props.transactionId) {
      getQuoteProposalByTransactionId(props.transactionId);
    }
  }, [props.transactionId, navigate]);
  // useEffect(() => {
  //   if (props.isEditable) {
  //     getCompanyDetails();
  //   }
  // }, []);
  const onTitleChange = (e: any) => {
    setTitle(e.target.value);
  };
  const onPreparedForChange = (e: any) => {
    setPreparedFor(e.target.value);
  };
  const onPreparedByChange = (e: any) => {
    setPreparedBy(e.target.value);
  };
  const onAcceptanceFormDescriptionChange = (e: any) => {
    setAcceptanceFormDescription(e.target.value);
  };
  const onWebsiteUrlChange = (e: any) => {
    setWebsite(e.target.value);
  };
  const onCompanyOverviewChange = (e: any) => {
    setCompanyOverview(e.target.value);
  };
  const onAboutUsChange = (e: any) => {
    setAboutUs(e.target.value);
  };
  const onVisionChange = (e: any) => {
    setVision(e.target.value);
  };
  const onMissionChange = (e: any) => {
    setMission(e.target.value);
  };
  const onproposalBreakdownDescriptionChange = (e: any) => {
    setProposalBreakdownDescription(e.target.value);
  };
  const onProposalComparisonDescriptionChange = (e: any) => {
    setProposalComparisonDescription(e.target.value);
  };
  const onCancelTemplateDetailsToSave = () => {
    getQuoteProposalByTransactionId(props.transactionId);
  };

  const getQuoteProposalByTransactionId = (transactionId: any) => {
    if (!props.isEditable) {
      setLoading(true);
    }
    var token = CommonValues.GetToken();
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/quote/${transactionId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .request(config)
      .then((response: any) => {
        setTitle(response.data.title);
        setPreparedFor(response.data.preparedFor);
        setPreparedBy(response.data.preparedBy);
        setPolicyDetails(response.data.policyDetails);
        setCoverageDetails(response.data.coverageDetails);
        setAssetsInformation(response.data.assetsDetails);
        // setProposalBreakdown(propBreakDown);
        setSelectedTemplate(response.data.templateId);
        setOurProposal(response.data.ourProposalDetails);
        setVideoUrl(response.data.videoUrl);
        setLogoURL(response.data.logoURL);
        setWebsite(response.data.website);
        setAboutUs(response.data.aboutUsDescription);
        setVision(response.data.visionDescription);
        setMission(response.data.missionDescription);
        setCompanyOverview(response.data.companyOverviewDescription);
        setPrimaryColor(response.data.primaryColor || "#243353");
        setSecondaryColor(response.data.secondaryColor || "#E0677D");
        setTeamMembers(typeof response.data.teamMembers === "string" ? JSON.parse(response.data.teamMembers) : response.data.teamMembers || []);
        setDocumentType(response.data.documentType);
        setAcceptanceFormDescription(response.data.acceptanceFormDescription);
        setProposalComparisonDescription(response.data.proposalComparisonDescription);
        setProposalBreakdownDescription(response.data.proposalBreakdownDescription);
        setTemplateImages(response.data.images);
        setEndorsementsExclusions(response.data.endorsementsExclusions);
        setSaveLoading(false);
        setTimeout(() => {
          setLoading(false);
        }, 200);
      })
      .catch((error: any) => {
        setLoading(false);
        setSaveLoading(false);
      });
  };

  const onTemplateDetailsSave = (policydata: any, coveragedata: any, assetdata: any, endorsementdata: any, ourProposalData: any) => {
    setSaveLoading(true);
    const token = CommonValues.GetToken();
    var data = {
      transactionId: props.transactionId,
      templateId: selectedTemplate,
      logoURL: logoURL,
      website: website,
      title: title,
      proposalYear: "",
      preparedFor: preparedFor,
      preparedBy: preparedBy,
      companyOverviewDescription: companyOverview,
      aboutUsDescription: aboutUs,
      visionDescription: vision,
      missionDescription: mission,
      proposalBreakdownDescription: proposalBreakdownDescription,
      policyDetails: policydata == undefined || policydata == null ? policyDetails : policydata,
      coverageDetails: coveragedata == undefined || coveragedata == null ? coverageDetails : coveragedata,
      assetsDetails: assetdata == undefined || assetdata == null ? assetsInformation : assetdata,
      proposalComparisonDescription: proposalComparisonDescription,
      currentPlanDetails: "",
      ourProposalDetails: ourProposalData == undefined || ourProposalData == null ? ourProposal : ourProposalData,
      acceptanceFormDescription: acceptanceFormDescription,
      contactUsDetails: "",
      documentType: documentType,
      videoUrl: videoUrl,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      teamMember: JSON.stringify(teamMembers),
      EndorsementsExclusions: endorsementdata == undefined || endorsementdata == null ? endorsementsExclusions : endorsementdata,
    };
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/update-qp-metadata`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "Application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        getQuoteProposalByTransactionId(props.transactionId);
        toast.current.show({ severity: "success", summary: "Success", detail: " Details saved successfully", life: 3000 });
      })
      .catch((error: any) => {
        setSaveLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else if (error.response.status === 404) {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while saving  the company details", life: 3000 });
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while saving the company details", life: 3000 });
          }
        }
      });
  };
  const onShareProposalClicked = () => {
    window.open(`/quoteproposal/${props.transactionId}`);
  };
    const onNewProposalClick = () => {
      navigate(`/newquoteproposal/${Guid.newGuid()}`);
    };
  return (
    <div>
      <Toast ref={toast} />

      {loading ? (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
          <p className="d-flex align-items-center justify-content-center">
            Processing Proposal...
            <div className="spinner-border text-purple ms-2 " role="status">
              <span className="visually-hidden">Processing...</span>
            </div>
          </p>
        </div>
      ) : (
        <>
          {props.selectedTemplate == 2 || selectedTemplate == 2 ? (
            <>
              <ProposalCover2
                isEditable={props.isEditable}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                teamMembers={teamMembers}
                preparedFor={preparedFor}
                preparedBy={preparedBy}
                websiteurl={website}
                logoURL={logoURL}
                onPreparedForChange={onPreparedForChange}
                onPreparedByChange={onPreparedByChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                title={title}
                onTitleChange={onTitleChange}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />{" "}
              <br />
              <CompanyOverview
                isEditable={props.isEditable}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                companyOverview={companyOverview}
                aboutUs={aboutUs}
                vision={vision}
                mission={mission}
                teamMembers={teamMembers}
                onCompanyOverviewChange={onCompanyOverviewChange}
                onAboutUsChange={onAboutUsChange}
                onVisionChange={onVisionChange}
                onMissionChange={onMissionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />{" "}
              <br />
              <ProposalBreakdown2
                isEditable={props.isEditable}
                proposalBreakdownDescription={proposalBreakdownDescription}
                policyDetails={policyDetails}
                coverageDetails={coverageDetails}
                assetsInformation={assetsInformation}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                onproposalBreakdownDescriptionChange={onproposalBreakdownDescriptionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                onSetAssetsData={setAssetsInformation}
                onSetCoverageData={setCoverageDetails}
                onSetPolicyData={setPolicyDetails}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
              <br />
              {ourProposal?.replace(/^"|"$/g, "").trim() ? (
                <>
                  <ProposalComparison2
                    isEditable={props.isEditable}
                    ourProposal={ourProposal}
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    proposalComparisonDescription={proposalComparisonDescription}
                    onSetProposalData={setOurProposal}
                    onProposalComparisonDescriptionChange={onProposalComparisonDescriptionChange}
                    onTemplateDetailsSave={onTemplateDetailsSave}
                    onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                    saveLoading={saveLoading}
                    templateImages={templateImages}
                    isGeneratingPdf={props.isGeneratingPdf}
                  />
                  <br />
                </>
              ) : null}
              {videoUrl != "" && videoUrl != null ? (
                <>
                  <ShowVideo2
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    videoUrl={videoUrl}
                    isGeneratingPdf={props.isGeneratingPdf}
                  />{" "}
                  <br />
                </>
              ) : null}
              <AcceptanceForm2
                isEditable={props.isEditable}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                acceptanceFormDescription={acceptanceFormDescription}
                onAcceptanceFormDescriptionChange={onAcceptanceFormDescriptionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />{" "}
              <br />
              <ContactUs2
                isEditable={props.isEditable}
                preparedBy={preparedBy}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                website={website}
                logoURL={logoURL}
                onPreparedByChange={onPreparedByChange}
                onWebsiteUrlChange={onWebsiteUrlChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />{" "}
              <br />
            </>
          ) : (
            <>
              <ProposalCover
                preparedFor={preparedFor}
                preparedBy={preparedBy}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                website={website}
                logoURL={logoURL}
                onPreparedForChange={onPreparedForChange}
                onPreparedByChange={onPreparedByChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                isEditable={props.isEditable}
                title={title}
                onTitleChange={onTitleChange}
                onWebsiteUrlChange={onWebsiteUrlChange}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
              <br />
              <Description
                isEditable={props.isEditable}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                websiteurl={website}
                aboutUs={aboutUs}
                companyOverview={companyOverview}
                vision={vision}
                mission={mission}
                teamMembers={teamMembers}
                companyDetails={companyDetails}
                logoURL={logoURL}
                onCompanyOverviewChange={onCompanyOverviewChange}
                onAboutUsChange={onAboutUsChange}
                onVisionChange={onVisionChange}
                onMissionChange={onMissionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
              <br />
              <ProposalBreakdown
                isEditable={props.isEditable}
                proposalBreakdownDescription={proposalBreakdownDescription}
                policyDetails={policyDetails}
                coverageDetails={coverageDetails}
                assetsInformation={assetsInformation}
                endorsementsExclusions={endorsementsExclusions}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                onproposalBreakdownDescriptionChange={onproposalBreakdownDescriptionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                onSetAssetsData={setAssetsInformation}
                onSetCoverageData={setCoverageDetails}
                onSetPolicyData={setPolicyDetails}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
              <br />
              {ourProposal?.replace(/^"|"$/g, "").trim() ? (
                <>
                  <ProposalComparison
                    isEditable={props.isEditable}
                    ourProposal={ourProposal}
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    proposalComparisonDescription={proposalComparisonDescription}
                    onSetProposalData={setOurProposal}
                    onProposalComparisonDescriptionChange={onProposalComparisonDescriptionChange}
                    onTemplateDetailsSave={onTemplateDetailsSave}
                    onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                    saveLoading={saveLoading}
                    templateImages={templateImages}
                    isGeneratingPdf={props.isGeneratingPdf}
                  />
                  <br />
                </>
              ) : null}
              {videoUrl != "" && videoUrl != null ? (
                <>
                  <ShowVideo
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    videoUrl={videoUrl}
                    saveLoading={saveLoading}
                    isGeneratingPdf={props.isGeneratingPdf}
                  />{" "}
                  <br />
                </>
              ) : null}{" "}
              <AcceptanceForm
                isEditable={props.isEditable}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                acceptanceFormDescription={acceptanceFormDescription}
                onAcceptanceFormDescriptionChange={onAcceptanceFormDescriptionChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
              <br />
              <ContactUs
                isEditable={props.isEditable}
                preparedBy={preparedBy}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                website={website}
                onPreparedByChange={onPreparedByChange}
                onWebsiteUrlChange={onWebsiteUrlChange}
                onTemplateDetailsSave={onTemplateDetailsSave}
                onCancelTemplateDetailsToSave={onCancelTemplateDetailsToSave}
                saveLoading={saveLoading}
                templateImages={templateImages}
                isGeneratingPdf={props.isGeneratingPdf}
              />
            </>
          )}
          {props.isEditable  && !props.isGeneratingPdf?
          <>
          <div className="border-top pt-3 d-flex justify-content-end mb-2 mt-2">
            <Button label="Create New " severity="secondary" icon="fa fa-plus" className="me-2 company-save-btn" onClick={onNewProposalClick} style={{ borderRadius: "6px" }} />

            {props.transactionId && (
              <Button label="Share proposal" icon="fa fa-share" iconPos="right" onClick={onShareProposalClicked} className="company-save-btn" />
            )}
          </div>
          </>
          :
          null}
        </>
      )}
    </div>
  );
}
